export default __webpack_public_path__ + "static/Concept2-e35289ec9064b2f861180da627554528.png";